(() => {
  const maps = () => document.querySelectorAll('[data-tp-map]');
  const optionalConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy?.analyticsProcessingAllowed?.() && privacy?.marketingAllowed?.() && privacy?.preferencesProcessingAllowed?.());
  };
  const syncMaps = () => {
    const allowed = optionalConsent();
    maps().forEach((map) => {
      const iframe = map.querySelector('iframe');
      const placeholder = map.querySelector('[data-map-placeholder]');
      if (allowed && !iframe && map.dataset.mapSrc) {
        const frame = document.createElement('iframe');
        frame.src = map.dataset.mapSrc;
        frame.title = map.dataset.mapTitle;
        frame.loading = 'lazy';
        frame.referrerPolicy = 'no-referrer';
        frame.allowFullscreen = true;
        map.appendChild(frame);
        if (placeholder) placeholder.hidden = true;
      } else if (!allowed) {
        iframe?.remove();
        if (placeholder) placeholder.hidden = false;
      }
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tp-cookie-preferences]');
    if (!button) return;
    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
    } else {
      const preferences = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (preferences) preferences.click();
      else if (window.privacyBanner?.loadBanner) window.privacyBanner.loadBanner();
    }
  });
  document.addEventListener('visitorConsentCollected', syncMaps);
  document.addEventListener('shopify:section:load', syncMaps);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) syncMaps(); });
  }
  syncMaps();
})();
